//Quick View

$(document).ready(function () {
  
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
  
  $('#Quantity-product-template').change(function(){
    if($(this).hasClass('input--error')){
      $('.product-form__error-message-wrapper').addClass('product-form__error-message-wrapper--hidden');
      $(this).removeClass('input--error');
    }
  })
  
  quantity();
  
  $('.small_link').change(function(){
  	var val = $(this).val();
    if(val){
    	window.location.href = val;
    }
  })
  
  $('.js-update-qty').click(function(){
  	var quantity = $(this).parent().find('input');
    var type = $(this).data('type');
    if(type == 1){
      quantity.val(parseInt(quantity.val())+1)
    }else {
      if(quantity.val() > 1){
          quantity.val(quantity.val()-1)
      }
    }
  })
  
  setTimeout(function(){
  	$('.box_item_review li').each(function(){
      let content = [],
          author = [],
          date = [];
      $(this).find('.spr-review').each(function(){
        content.push($(this).find('.spr-review-content-body').text());
        author.push($(this).find('.spr-review-header-byline strong').first().text());
        date.push($(this).find('.spr-review-header-byline strong').last().text());
      })
      var random = Math.floor(Math.random()*content.length);
      
      $(this).find('.content_review').text(content[random]);
      if(author[random]){
      	$(this).find('.date_review').text(author[random] + " | " + date[random]);
      }
    })
    
    $('.review_content').remove();
    
    $('.list-review').each(function(){
      let content = [],
          author = [],
          date = [];
      $(this).find('.spr-review').each(function(){
        content.push($(this).find('.spr-review-content-body').text());
        author.push($(this).find('.spr-review-header-byline strong').first().text());
        date.push($(this).find('.spr-review-header-byline strong').last().text());
      })
      var random = Math.floor(Math.random()*content.length);
      
      $(this).find('.content_review').text(content[random]);
      if(author[random]){
      	$(this).find('.author_reivew').text(author[random]);
        $(this).find('.date_review').text(date[random]);
      }
    })
    $('.review_content_page').remove();
  },3000)
  
  $("a").on('click', function(event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 135
      }, 800);
    }
  });
  
  $('.js-AddToCart').click(function() {
    if ($('.wish_page').is(':checked')) {
      var confirmURL = confirm('Product added in shopping cart. Do you want to move to cart?');
      var check;
        $('.wish_page').each(function(i, v) {
          if ($(this).is(':checked')) {

            let product_id = $(this).val();
            let product_handle = $(this).data('product-handle');

            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
              $(product.variants).each(function (i, v) {
                var_id = v.id;
                processCart();
              });
            });

            function processCart() {
              jQuery.post('/cart/add.js', {
                quantity: 1,
                id: var_id
              }, null, "json").done(function() {
                if(confirmURL){
                  window.location.href = "/cart";
                }else {
                	$('#CartCount span[data-cart-count]').text(parseInt($('#CartCount span[data-cart-count]').text()) + 1);
                }
              })
              .fail(function($xhr) {
                var data = $xhr.responseJSON;
                $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
              });
            }

          }
        })
    
    } else {
      alert('Please select at least one item you want to move to cart.');
    }
  })
  
  $(document).on('click','.js-AddproductCart',function(){
    var product_handle = $(this).data('handle');
    var urlimage = $(this).parents('.grid-view-item').find('.grid-view-item__image').attr('srcset');
    var title = $(this).parent().parent().parent().parent().find('.product-card__title').text();
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      $(product.variants).each(function (i, v) {
        var_id = v.id;
        processCart();
      });
    });
    function processCart() {
      jQuery.post('/cart/add.js', {
        quantity: 1,
        id: var_id
      },null,"json").done(function (t) {
        $('.cart-popup-item__image-wrapper').find('img').remove();
        $('.cart-popup-item__image-wrapper').removeClass('hide').append('<img src="'+urlimage+'" class="cart-popup-item__image">');
        $('.cart-popup-item__title').text(title);
        $('.quantity_card').text(1);
        $('span[data-cart-popup-cart-quantity]').text(parseInt($('#CartCount span[data-cart-count]').text()) + 1);
        $('#CartCount span[data-cart-count]').text(parseInt($('#CartCount span[data-cart-count]').text()) + 1);
        $('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');
        $('.cart-popup__close').addClass('js-hidden-popup');
        $('.cart-popup__dismiss-button').addClass('js-hidden-popup');
      })
      .fail(function ($xhr) {
        var data = $xhr.responseJSON;
      });
    }
  })
  
  $(document).on('click', '.js-hidden-popup', function(){
    $('.cart-popup-item__image-wrapper').addClass('hide').find('.cart-popup-item__image').remove();
    $('.cart-popup-item__title').empty();
    $('.quantity_card').empty();
    $('span[data-cart-popup-cart-quantity]').empty();
    $('.cart-popup-wrapper').addClass('cart-popup-wrapper--hidden');
    $('.cart-popup__close').removeClass('js-hidden-popup');
    $('.cart-popup__dismiss-button').removeClass('js-hidden-popup');
  })
  
  $('.clear-cart').on('click',function(e){
    if(confirm('Do you want to empty all products in your cart?')){
      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
          window.location.href = "/cart";
        },
        dataType: 'json'
      });
    }
  })
  
  var number = []
  $('.box_item_review li').each(function(){
    number.push($(this).data('number-review'));
  })
  var numberReverse = number.sort().reverse();
  for(var i=0;i<3;i++){
  	$('.box_item_review li[data-number-review="'+numberReverse[i]+'"]').removeClass('review_item').show().css({order:i+1});
    
  }
  
  $('.review_item').remove();
  
  $(document).on('click', '.js-open-window', function(){
    if($(this).data('type') == 'fb'){
    	window.open('http://www.facebook.com/sharer/sharer.php?u='+$(this).data('url'),'','width=804,height=504');
    }else {
    	window.open('http://twitter.com/intent/tweet?url='+$(this).data('url'),'','width=804,height=504');
    }
  })
  
  $('.js-toggle-nav-footer').click(function(){
    $(this).parent().find('.site-footer__rte').toggleClass('active');
    $(this).toggleClass('active');
  })
  
  $('#member_id_save').change(function(){
    rememberlogin();
  })
  
  $('#member_pwd_save').change(function(){
    rememberlogin();
  })
  
  $('.box_btn input[type="submit"]').click(function(){
    rememberlogin();
  })
  
  if(localStorage.getItem('email_login')){
  	$('input[name="customer[email]"]').val(localStorage.getItem('email_login'));
  }
  
  if(localStorage.getItem('password_login')){
  	$('input[name="customer[password]"]').val(localStorage.getItem('password_login'));
  }
  
  if($('.login_info').data('type') == "out"){
  	localStorage.removeItem('user_wishlist');
  }
  
  $('#number_count_review').text($('.prd_related tbody tr').length);
  
  $('.product-carousel').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    draggable: false,
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    draggable: false,
    accessibility: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplaySpeed: 2000,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplaySpeed: 2000,
        }
      },
      {
        breakpoint: 480,
        settings: {
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          autoplaySpeed: 2000,
        }
      }
    ]
  });
  
  $('.js-tab-faq a').click(function(){
  	var val_tab = $(this).data('type');
    $('.js-tab-faq li').removeClass('cate_all');
    $(this).parent().addClass('cate_all');
    
    if(val_tab == 'all'){
      $('.tab-question').show();
    }
    else {
      $('.faq-tab').hide();
      $('.tab-question-'+val_tab).show();
    }
  })
  
//   $(document).on('click','.qv-content a.wishlist-btn', function(){
//     var wishlist = localStorage.getItem('user_wishlist') || [];
//     if (wishlist.length > 0) {
//       wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
//     }
//       var productHandle = $(this).attr('data-product-handle');
//       var isRemove = $(this).hasClass('is-active wish_on');
//       /* Remove */
//       if($('.login_info').data('type') == 'in'){
//         if($(this).parent('.wishlist-btn').hasClass('is-active')) {
//           var confirmURL = confirm('product added to wishlist.');

//           if(confirmURL){
//             window.location.href = "/pages/wishlist";
//           }
//         }

//         if (isRemove) {
//           var removeIndex = wishlist.indexOf(productHandle);
//           wishlist.splice(removeIndex, 1);
//           localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
//           $(this).removeClass('is-active wish_on');
//         }
//         /* Add */ 
//         else {
//           wishlist.push(productHandle);
//           localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
//           $(this).addClass('is-active wish_on');
//           var confirmURL = confirm('product added to wishlist.');

//           if(confirmURL){
//             window.location.href = "/pages/wishlist";
//           }
//         }
//       }
//   })
  checkItemWishlist();
  
  $(document).on('mouseover', '.qv-product-images .item-zoom', function(){
    $('.qv-product-zomm').show().find('.item-zoom-'+$(this).data('id')).show();
  })
  
  $(document).on('mouseout', '.qv-product-images .item-zoom', function(){
    $('.qv-product-zomm').hide().find('.item-zoom').hide();
  })
});

function checkItemWishlist() {
  if(!$('.prd_related tbody tr').length > 0) {
    $('.group-btn-wishlist').hide();
  }
}

function wishlistUrl() {
	if($('.login_info').data('type') == 'in'){
    	window.location.href = "/pages/wishlist";
    }else {
    	window.location.href = "/account/login";
    }
}

function editInfoUrl() {
	if($('.login_info').data('type') == 'in'){
    	window.location.href = "/account/addresses";
    }else {
    	window.location.href = "/account/login";
    }
}

function coupontUrl() {
	if($('.login_info').data('type') == 'in'){
    	window.location.href = "/pages/coupon";
    }else {
    	window.location.href = "/account/login";
    }
}

function show(item){
  
  let check_ele = '#faq-'+item;
  
  if($(check_ele).css('display') == 'none') {
	$('tr.faqcnt').hide();
    $(check_ele).show();
  } else {
  	$(check_ele).hide();
  }

}

function tabover(name, no) {
	var tabs = $('.tab_'+name+'').find('li');
	tabs.each(function(idx) {
		var detail = $('.tabcnt_'+name+idx);
		var link = $(this).find('a');
		if(no == idx) {
			detail.show();
			link.addClass('active');
		} else {
			detail.hide();
			link.removeClass('active');
		}
	})
}

function removeItem(line){
  var confirmData = confirm('Do you want to delete selected item?');
  if(confirmData){
  	window.location.href = "/cart/change?line="+line+"&amp;quantity=0";
  }
}

$(document).on('click', '.js-delete-select-cart', function(){
  if(confirm('Do you want to delete selected item?')){
    $('.input-delete-select-cart').each(function(){
      var $this = $(this);
      var id = $(this).data('id');
      if($(this).is(':checked')){
        $.ajax({
          type: "POST",
          url: '/cart/update.js',
          data: {updates: {
            id: 0
          }},
          success: function(){
			$this.parent().parent().parent().remove();
          },
          dataType: 'json'
        });
      }
    })
  }
})


$(window).scroll(function(){
	var y=$(this).scrollTop();
	if( y > 300 ){
		$('.btn_scroll').fadeIn();
	} else {
		$('.btn_scroll').fadeOut();
	}
	if ($('.gnb').hasClass('fixed')) {
		if( y > 230 ){
			$('.favorite .viewsub').fadeIn();
		} else {
			$('.favorite .viewsub').fadeOut();
		}
	}
  
  $('.tabcnt_detail').each(function(){
    var id = $(this).data('id');
  	if(y >= $('.tabcnt_detail'+id).offset().top - 150 && y <= $('.tabcnt_detail'+id).offset().top + $('.tabcnt_detail'+id).height() - 130){
      $('.tab_detail li a.tab-'+id).addClass('active');
    }else {
      $('.tab_detail li a.tab-'+id).removeClass('active');
    }
  })
});

function scrollup(){
	$('html, body').animate({scrollTop:0}, 'slow');
}
function scrolldown(){
	$('html, body').animate({scrollTop:$(document).height()}, 'slow');
}

function rememberlogin(){
	if($('#member_id_save').is(':checked')){
      localStorage.setItem('email_login', $('input[name="customer[email]"]').val());
    }else {
    	localStorage.removeItem('email_login');
    }
    
    if($('#member_pwd_save').is(':checked')){
      localStorage.setItem('password_login', $('input[name="customer[password]"]').val());
    }else {
    	localStorage.removeItem('password_login');
    }
}

function joinAgree(){
  if($('#ck_agree').is(':checked') && $('#ck_privacy').is(':checked')){
    window.location.href = "/account/register";
  }
  else {
  	alert('Please agree to the Privacy Policy.');
  }
}

function quantity(){
  $(document).on('change', '.js-quantity',function(){
    var valQuantity = $('h5.qv-product-price').text();
    var total = $(this).val() * parseInt($.trim(valQuantity).substr(3, 100));
    var formatTotal = parseFloat(total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
    $('span.qv-product-price').text('USD'+formatTotal);
  })
  
  $(document).on('change','.js-quantity-product', function(){
  	var valQuantity = $('.price-item--sale').text();
    var total = $(this).val() * parseInt($.trim(valQuantity).substr(3, 100));
    var formatTotal = parseFloat(total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
    $('span.qv-product-price').text('USD'+formatTotal);
  })
}

function quickView() {
  $(document).on('click', ".quick-view", function () {
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle'),
        product_id = $(this).data('id');
    $('#quick-view').addClass(product_handle);
    
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);
      $('#quick-view .wishlist-btn').attr('data-product-handle', product_handle);
      var imageCount = $(images).length;
      
	  var html = "<a href='javascript:void(0);' class='facebook js-open-window' data-type='fb' data-url='"+ window.location.origin + product.url +"'>facebook</a>";
      		html += '<a href="javascript:;" class="twitter js-open-window" data-type="tw" data-url="'+ window.location.origin + product.url +'">twitter</a>';
      $('.sns').append(html);
      
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div class="item-zoom item-zoom-'+i+'" data-id="'+i+'"><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
          $('.qv-product-thumnail').append(image_embed);
          $('.qv-product-zomm').append(image_embed);

          $('.qv-product-images').slick({
            'dots': false,
            'arrows': false,
            'respondTo': 'min',
            'useTransform': false,
            asNavFor: '.qv-product-thumnail'
          }).css('opacity', '1');
          
          $('.qv-product-thumnail').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.qv-product-images',
            dots: false,
            centerMode: true,
            focusOnSelect: true
          }).css('opacity', '1');

        } else {
          image_embed = '<div class="item-zoom item-zoom-'+i+'" data-id="'+i+'"><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
          $('.qv-product-thumnail').append(image_embed);
          $('.qv-product-zomm').append(image_embed);
        }
      });
      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        $(option.values).each(function (i, value) {
          $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
        });
      });
      $(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {
          $('.qv-add-button').prop('disabled', true).val('Sold Out');
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.qv-product-price').html('USD<strong>' + price + '</strong>');
          if (original_price > 0) {
            $('.qv-product-original-price').text('USD' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
    });

    $(document).on("change", "#quick-view select", function () {
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            $('.qv-product-price').text('$' + price);
            $('.qv-product-original-price').text('$' + original_price);
            if (v_inv == null) {
              $('.qv-add-button').prop('disabled', false).val('Add to Cart');
            } else {
              if (v.inventory_quantity < 1) {
                $('.qv-add-button').prop('disabled', true).val('Sold Out');
              } else {
                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
              }
            }
          }
        });
      });
    });
    $.fancybox({
      href: '#quick-view',
      maxWidth: 1100,
      maxHeight: 700,
      fitToView: true,
      width: '90%',
      height: '80%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      helpers : { 
        overlay : {closeClick: false}
      },
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function () {
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          if(qty > 0){
//             $('.qv-add-to-cart .group-btn .cart').addClass('loading_checkout');
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },
                        null,
                        "json"
                       ).done(function () {
              $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
//               $('.qv-add-to-cart .group-btn .cart').removeClass('loading_checkout');
            })
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
//               $('.qv-add-to-cart .group-btn .cart').removeClass('loading_checkout');
            });
          }
          }else {
          	alert('Must purchase at least 1 piece');
            $('.qv-quantity').val(1);
          }
        });
        
        $(document).on("click", ".js_quickview_checkout", function () {
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          if(qty > 0){
//             $('.qv-add-to-cart .group-btn .buy').addClass('loading_checkout');
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },null,"json").done(function ($resspon) {
              window.location.href = "/checkout";
            })
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
//               $('.qv-add-to-cart .group-btn .buy').removeClass('loading_checkout');
            });
          }
          }else {
          	alert('Must purchase at least 1 piece');
            $('.qv-quantity').val(1);
          }
        });
        
        
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
    
    $('#number_review').text($.trim($(this).closest('.product-card').find('.count li:nth-child(2)').text()).substr(8, 100));
    
    if($(this).parents('.quick').find('a.wishlist-btn').hasClass('wish_on')){
      $('.qv-content a.wishlist-btn').addClass('is-active wish_on').removeClass('wishlist');
    }
    
  });
};

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});

function eaChg(type) {
  var quantity = $('input[name="quantity"]');
  if(type == 1){
	quantity.val(parseInt(quantity.val())+1)
  }else {
    if(quantity.val() > 1){
    	quantity.val(quantity.val()-1)
    }
  }
}

function showSocial(){
	$('.social-sharing').toggle();
}

function toggle_next(data){
  $('#title_'+data).toggleClass('active');
  if ($('#title_'+data).hasClass('active')){
    $('#toggle_'+data).slideUp('fast');
  }else {
  	$('#toggle_'+data).slideDown('fast');
  }
  
}